/**
 * DateRangeSelector component - Date range selection for progress data.
 *
 * Provides preset date range options (7, 14, 30, 60, 90 days) with
 * Material Design styling matching the HomePage aesthetic.
 */

import React from 'react';

export interface DateRangeOption {
  value: number;
  label: string;
}

interface DateRangeSelectorProps {
  selectedRange: number;
  onChange: (days: number) => void;
  options?: DateRangeOption[];
  className?: string;
}

const DEFAULT_OPTIONS: DateRangeOption[] = [
  { value: 7, label: '7 Days' },
  { value: 14, label: '14 Days' },
  { value: 30, label: '30 Days' },
  { value: 60, label: '60 Days' },
  { value: 90, label: '90 Days' }
];

const DateRangeSelector: React.FC<DateRangeSelectorProps> = ({
  selectedRange,
  onChange,
  options = DEFAULT_OPTIONS,
  className = ''
}) => {
  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      <label className="text-sm font-semibold text-neutral-700">
        Time Range:
      </label>
      <select
        value={selectedRange}
        onChange={(e) => onChange(Number(e.target.value))}
        className="px-4 py-2.5 border-2 border-primary-300 rounded-xl bg-white text-neutral-800 font-medium focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-400 transition-all duration-200 hover:border-primary-400 shadow-soft cursor-pointer"
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default DateRangeSelector;
